import React, { useState } from 'react'
function Home() {

    
    return (
        <div>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est deleniti reprehenderit quod cupiditate qui iure quo, recusandae numquam veniam consequatur sint quisquam et quidem aspernatur laudantium molestias libero, debitis veritatis?
            Consectetur, id. Maiores dolor sit, beatae nisi ullam veniam reiciendis numquam aliquam, blanditiis dignissimos ipsum dolorem facilis cupiditate aspernatur cum? Repudiandae odio rem aperiam doloribus expedita a eveniet recusandae amet?
            Soluta, repellendus. Reprehenderit unde magnam perferendis quisquam, facilis eaque tenetur ea ad eveniet ipsam dolore reiciendis obcaecati, libero ex deleniti, placeat beatae velit. Molestias iusto dolorem nulla quisquam ea similique.
            Veniam officia explicabo ipsa dolorum sunt vero ipsam hic cum perspiciatis, impedit a amet, sequi dignissimos inventore, voluptates repellat error. Magni cupiditate esse aut placeat laborum, voluptatibus quibusdam rerum assumenda!
            Accusantium atque dolore quasi facere qui nisi, officia deserunt sunt dolorum dicta! Placeat accusantium fuga beatae! Distinctio dolores ratione, voluptates qui vel ab molestias provident! Autem magni vel veritatis voluptas.
        </div>
    )
}

export default Home

